<template>
  <div class="groceries-content">
    <h1>Groceries page</h1>
    <br />
    <br />
    <v-icon x-large>mdi-file-code-outline</v-icon>
    <p>Coming soon...</p>
    <v-btn x-large color="primary" @click="$router.push('/')">Click to go back</v-btn>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
.groceries-content {
  margin: 20px;
}
</style>